import { useTranslations } from 'next-intl';
import KeyIconItem from './key-icon-item';
import {
  CatIconWrench,
  CatIconCancelUndo,
  CatIconCube,
  CatIconReplace
} from 'components/blocks-components';

const KeyIconsSection = () => {
  const t = useTranslations();

  return (
    <>
      <section className="ps-4 d-md-none">
        <KeyIconItem
          title={t('CAT_QO_REMANUFACTURED')}
          icon={<CatIconWrench />}
        />
        <KeyIconItem title={t('NON_RETURNABLE')} icon={<CatIconCancelUndo />} />
        <KeyIconItem title={t('KIT')} icon={<CatIconCube />} />
        <KeyIconItem title={t('REPLACED')} icon={<CatIconReplace />} />
      </section>
      <section className="d-md-block d-none">
        <KeyIconItem
          title={t('CAT_QO_REMANUFACTURED')}
          icon={<CatIconWrench size="lg" />}
        />
        <KeyIconItem
          title={t('NON_RETURNABLE')}
          icon={<CatIconCancelUndo size="lg" />}
        />
        <KeyIconItem title={t('KIT')} icon={<CatIconCube size="lg" />} />
        <KeyIconItem
          title={t('REPLACED')}
          icon={<CatIconReplace size="lg" />}
        />
      </section>
    </>
  );
};

export default KeyIconsSection;
